import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormHelperText, MenuItem, makeStyles } from '@material-ui/core';

import Button from 'components/common/Buttons/Button';
import ThreeppModal from 'components/common/Modal/Modal';
import { Select } from 'components/common/Select/Select';

const useStyles = makeStyles(theme => ({
  portalLanSelectionModal: {
    maxWidth: theme.sizes.modalMaxWidth,
    '& .action-row': {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    '& .field-info': {
      color: theme.palette.textColor
    }
  }
}));

export const PortalLanguageSelection = props => {
  const { isOpen, updatePortalLang, portalSelectedLanguage } = props;
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState('english');
  const classes = useStyles();

  const handleSave = () => {
    updatePortalLang(selectedLanguage);
  };

  const createLanguageOptions = () => {
    const dropdownOptions = [];
    const languages = [
      { english: 'English' },
      { spanish: 'Spanish' },
      { german: 'German' },
      { french: 'French' },
      { italian: 'Italian' },
      { japanese: 'Japanese' },
      { portuguese: 'Portuguese' },
      { chinese: 'Chinese' },
      { korean: 'Korean' }
    ];
    languages.forEach(language =>
      Object.entries(language).forEach(([key, value]) =>
        dropdownOptions.push(
          <MenuItem value={key} key={key}>
            {value}
          </MenuItem>
        )
      )
    );
    return dropdownOptions;
  };

  useEffect(() => {
    portalSelectedLanguage && setSelectedLanguage(portalSelectedLanguage);
  }, [portalSelectedLanguage]);

  return (
    <ThreeppModal classes={classes.portalLanSelectionModal} header={t('portalLanguageSelection.selectLanguage')} size="sm" isOpen={isOpen}>
      <Select
        variant="filled"
        label={t('portalLanguageSelection.language')}
        value={selectedLanguage}
        onChange={e => setSelectedLanguage(e.target.value)}
        defaultValue=""
      >
        {createLanguageOptions()}
      </Select>
      <FormHelperText className="field-info">{t('portalLanguageSelection.languageInfo')}</FormHelperText>
      <div className="action-row">
        <div className="btn-group">
          <Button className="btn-save" buttonStyle="primary" onClick={handleSave}>
            {t('portalLanguageSelection.save')}
          </Button>
        </div>
      </div>
    </ThreeppModal>
  );
};

export default PortalLanguageSelection;
